module.exports = __webpack_public_path__ + "static/img/evidence.95d8c92.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/evidence.png
// module id = vaxG
// module chunks = 1 3